import { createTheme } from '@mui/material/styles';
import { ptBR } from '@mui/material/locale';

/**
 * Tema do sistema.
 *
 * Usa `colorSchemes` com CSS variables em vez de dois temas e um alternador:
 * o MUI gera as variáveis dos dois esquemas e o navegador troca sozinho
 * conforme `prefers-color-scheme`, sem re-render do React e sem piscar no
 * primeiro carregamento.
 *
 * `ptBR` traduz os textos internos dos componentes (paginação da tabela,
 * rótulos de acessibilidade, campos de seleção).
 */
export const tema = createTheme(
  {
    cssVariables: { colorSchemeSelector: 'data-mui-color-scheme' },
    colorSchemes: {
      light: {
        palette: {
          primary: { main: '#0b5cab' },
          background: { default: '#f5f7fa', paper: '#ffffff' },
        },
      },
      dark: {
        palette: {
          primary: { main: '#6ab0f3' },
          background: { default: '#0b1017', paper: '#131a24' },
        },
      },
    },

    shape: { borderRadius: 10 },

    typography: {
      fontFamily: [
        'ui-sans-serif',
        'system-ui',
        'Segoe UI',
        'Roboto',
        'Helvetica',
        'Arial',
        'sans-serif',
      ].join(','),
      h1: { fontSize: '1.25rem', fontWeight: 600 },
      h2: { fontSize: '1rem', fontWeight: 600 },
    },

    components: {
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: { root: { textTransform: 'none', fontWeight: 600 } },
      },
      MuiCard: {
        defaultProps: { variant: 'outlined' },
      },
      MuiTableCell: {
        styleOverrides: {
          head: { fontWeight: 600, whiteSpace: 'nowrap' },
        },
      },
      MuiChip: {
        styleOverrides: { root: { fontWeight: 600 } },
      },
    },
  },
  ptBR,
);

/** Largura da barra lateral. Vive aqui porque o layout e o conteúdo a usam. */
export const LARGURA_SIDEBAR = 248;

/**
 * Largura da barra retraída: cabe o ícone e a área de clique, e nada mais.
 * Menos do que isto e o alvo fica pequeno demais para o mouse.
 */
export const LARGURA_SIDEBAR_RETRAIDA = 68;
